<template>
  <span>
    <span v-if="loading">
      <i class="fa fa-spinner fa-spin"></i>&nbsp; Please wait&hellip;
    </span>
    <span v-else-if="error">Error: {{ error }}</span>

    <span v-if="user">
      {{ user.displayName }}
      <span v-if="user.submerchantReference"
        >({{ user.submerchantReference }})</span
      >
    </span>
  </span>
</template>
<script>
export default {
  name: "SubmerchantUserFragment",
  props: {
    userId: {
      type: String,
      required: true
    },
    submerchantId: {
      type: String,
      required: true
    },
    linkClasses: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      user: null,
      error: null,
      loading: false
    };
  },
  methods: {
    loadSubmerchantUser() {
      this.loading = true;

      this.axios
        .get(`/v1/submerchants/${this.submerchantId}/users/${this.userId}`)
        .then(response => {
          this.loading = false;
          if (response.status !== 200) {
            this.error = response.statusText;
            return;
          }

          this.user = response.data;
        })
        .catch(error => {
          this.loading = false;
          // Request failed.
          this.error = error.response.statusText;
        });
    }
  },
  mounted() {
    this.loadSubmerchantUser();
  }
};
</script>

<style></style>
